var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export function validProgress(progress) {
    if (!progress || progress < 0) {
        return 0;
    }
    if (progress > 100) {
        return 100;
    }
    return progress;
}
export function getPathStyles(offset, percent, strokeColor, strokeWidth, gapDegree, gapPosition) {
    if (gapDegree === void 0) { gapDegree = 0; }
    var radius = 50 - strokeWidth / 2;
    var beginPositionX = 0;
    var beginPositionY = -radius;
    var endPositionX = 0;
    var endPositionY = -2 * radius;
    switch (gapPosition) {
        case 'left':
            beginPositionX = -radius;
            beginPositionY = 0;
            endPositionX = 2 * radius;
            endPositionY = 0;
            break;
        case 'right':
            beginPositionX = radius;
            beginPositionY = 0;
            endPositionX = -2 * radius;
            endPositionY = 0;
            break;
        case 'bottom':
            beginPositionY = radius;
            endPositionY = 2 * radius;
            break;
        default:
    }
    var pathString = "M 50,50 m " + beginPositionX + "," + beginPositionY + "\n   a " + radius + "," + radius + " 0 1 1 " + endPositionX + "," + -endPositionY + "\n   a " + radius + "," + radius + " 0 1 1 " + -endPositionX + "," + endPositionY;
    var len = Math.PI * 2 * radius;
    var pathStyle = {
        stroke: strokeColor,
        strokeDasharray: (percent / 100) * (len - gapDegree) + "px " + len + "px",
        strokeDashoffset: "-" + (gapDegree / 2 + (offset / 100) * (len - gapDegree)) + "px",
        transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s',
    };
    return {
        pathString: pathString,
        pathStyle: pathStyle,
    };
}
export function stripPercentToNumber(percent) {
    return +percent.replace('%', '');
}
export function toArray(symArray) {
    return Array.isArray(symArray) ? symArray : [symArray];
}
export var handleGradient = function (strokeColor) {
    var _a = strokeColor.from, from = _a === void 0 ? '#1890ff' : _a, _b = strokeColor.to, to = _b === void 0 ? '#1890ff' : _b, _c = strokeColor.direction, direction = _c === void 0 ? 'to right' : _c, rest = __rest(strokeColor, ["from", "to", "direction"]);
    if (Object.keys(rest).length !== 0) {
        var sortedGradients = sortGradient(rest);
        return { backgroundImage: "linear-gradient(" + direction + ", " + sortedGradients + ")" };
    }
    return { backgroundImage: "linear-gradient(" + direction + ", " + from + ", " + to + ")" };
};
export var sortGradient = function (gradients) {
    var tempArr = [];
    Object.keys(gradients).forEach(function (key) {
        var formattedKey = parseFloat(key.replace(/%/g, ''));
        if (!isNaN(formattedKey)) {
            tempArr.push({
                key: formattedKey,
                value: gradients[key],
            });
        }
    });
    tempArr = tempArr.sort(function (a, b) { return a.key - b.key; });
    return tempArr.map(function (_a) {
        var key = _a.key, value = _a.value;
        return value + " " + key + "%";
    }).join(', ');
};
